import { Product } from "../interfaces/home_entity";

export const calculatePrice = (product: Product) => {
  const base = product.price ?? 0;
  const margin = product.marginPrice ?? 0;
  const discount = product.discountedPrice ?? 0;
  const gst = product.gst ?? 0;

  const priceWithMargin = base + (base * margin) / 100;
  const originalFinal =
    priceWithMargin + (priceWithMargin * gst) / 100;

  const priceAfterDiscount =
    base - (base * discount) / 100;

  const discountedWithMargin =
    priceAfterDiscount + (priceAfterDiscount * margin) / 100;

  const final =
    discountedWithMargin +
    (discountedWithMargin * gst) / 100;

  return {
    finalPrice: final,
    originalFinalPrice: originalFinal,
    discountPercent: discount,
  };
};